<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import ChubbnetRepository from '../repositories/chubbnet.repository';

const RENEWAL_EXPIRING_DAYS = 7;

const chubbnetRepository = new ChubbnetRepository();
const isOn = ref<boolean>(false);
const loading = ref<boolean>(false);
const renewalMessage = ref<string | undefined>();
const renewalDays = ref<number | undefined>();

const isRenewalExpiring = computed(
  () => renewalDays.value !== undefined && renewalDays.value <= RENEWAL_EXPIRING_DAYS,
);

onMounted(async () => {
  await refresh();
});

const refresh = async () => {
  try {
    loading.value = true;
    const status = await chubbnetRepository.getChubbnetStatus();
    isOn.value = status.isOn;
    renewalMessage.value = status.renewalMessage;
    renewalDays.value = status.renewalDays;
  } catch (error) {
    isOn.value = false;
    renewalMessage.value = undefined;
    renewalDays.value = undefined;
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <div class="container_header">
    <span>{{ loading ? 'Conectando Chubbnet...' : 'Estado Chubbnet: ' }}</span>
    <div class="toggle-status" :class="{ on: isOn, off: !isOn }">
      <span>{{ isOn ? 'ON' : 'OFF' }}</span>
    </div>
    <span v-if="renewalMessage" class="renewal-message" :class="{ expiring: isRenewalExpiring }">{{ renewalMessage }}</span>
    <div class="refresh-btn" @click="refresh">
      <img src="/icons/update.svg" alt="refresh" />
    </div>
  </div>
</template>

<style scoped>
.container_header {
  position: fixed;
  top: 10px;
  right: 80px;
  z-index: 999;
  margin: 0px 34px 0px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #fff;
  padding: 5px 10px;
}

.renewal-message {
  font-size: 13px;
  color: #555;
  white-space: nowrap;
  background-color: #f0f0f0;
  border-radius: 12px;
  padding: 3px 10px;
}

.renewal-message.expiring {
  color: #842029;
  background-color: #f8d7da;
}

.toggle-status {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
  border: none;
  color: white;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5) inset;
}

.toggle-status.on {
  color: #00ff00;
  border: 2px solid #00ff00;
  box-shadow: 0 0 20px #00ff00;
}

.toggle-status.off {
  color: #ff0000;
  border: 2px solid #ff0000;
  box-shadow: 0 0 20px #ff0000;
}
.refresh-btn {
  background: #7a7a7a;
  padding: 6px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  transition: background 0.2s ease;
}

.refresh-btn:hover {
  background: #9a9a9a;
}

.refresh-btn img {
  width: 20px;
  height: 20px;
}
</style>
